<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			id="exportTab"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			height="60vh"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
		>
			<el-table-column prop="date" label="日期" width="120px">
			</el-table-column>
			<el-table-column prop="total_ai_ratio" label="全站AI内容占比">
				<template slot-scope="scope">
					<span>
						{{
							scope.row.total_ai_ratio > 0 ? scope.row.total_ai_ratio + "%" : 0
						}}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="total_ai_count" label="总AI内容数量">
				<template slot-scope="scope">
					<span>
						{{ scope.row.statistics.total_ai_count }}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="news_ai_ratio" label="新闻AI内容占比">
				<template slot-scope="scope">
					<span>
						{{
							scope.row.news_ai_ratio > 0 ? scope.row.news_ai_ratio + "%" : 0
						}}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="news_ai_count" label="新闻AI内容数量">
				<template slot-scope="scope">
					<span>
						{{ scope.row.statistics.news_ai_count }}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="flash_ai_ratio" label="快讯AI内容占比">
				<template slot-scope="scope">
					<span>
						{{
							scope.row.flash_ai_ratio > 0 ? scope.row.flash_ai_ratio + "%" : 0
						}}
					</span>
				</template>
			</el-table-column>

			<el-table-column prop="flash_ai_count" label="快讯AI内容数量">
				<template slot-scope="scope">
					<span>
						{{ scope.row.statistics.flash_ai_count }}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="column_ai_ratio" label="专栏AI内容占比">
				<template slot-scope="scope">
					<span>
						{{
							scope.row.column_ai_ratio > 0
								? scope.row.column_ai_ratio + "%"
								: 0
						}}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="manual_ai_ratio" label="手动AI内容占比">
				<template slot-scope="scope">
					<span>
						{{
							scope.row.manual_ai_ratio > 0
								? scope.row.manual_ai_ratio + "%"
								: 0
						}}
					</span>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import { disInformation, delInformation, informationHome } from "@/api/article";
export default {
	props: ["tableData"],
	name: "",
	data() {
		return {
			value: true,
		};
	},
	methods: {
		showPreView(row) {
			let url = "https://me.news/contents/" + row.id;
			if (row.type == 2) {
				url = "https://me.news/news/" + row.id;
			}
			window.open(url, "预览");
		},

		detailView(row) {
			this.$router.push({
				path: "/webdata/singleList",
				query: { id: row.id },
			});
		},
	},
};
</script>

<style scoped></style>
